import { requestPayment } from 'Cloud/Application/Payment';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardActions } from 'reactApp/modules/creditCard/creditCard.module';
import { getFeatureUnionQuotaTariffsList } from 'reactApp/modules/features/features.selectors';
import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { updateSubscriptionsRequest } from 'reactApp/modules/subscriptions/subscriptions.module';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { getTariffsList } from 'reactApp/sections/QuotaLanding/TariffsPlans/TariffsPlans.selectors';
import { RootState } from 'reactApp/store';
import { ITariffsByTab } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
/**
 * Хук покупки рекомендованного тарифа "Единой квоты"
 * Используется в чистилке как тариф по умолчанию
 */
export const useBuyCleanerTariff = (): {
    tariffId?: string;
    tariffPrice?: number;
    tariffValue?: string;
    onBuy: () => void;
} => {
    const dispatch = useDispatch();
    const tariffList = useSelector((state: RootState) => getTariffsList(state, ''));
    const isUnionQuotaTariffsList = useSelector(getFeatureUnionQuotaTariffsList);

    const recommendedTariff: Partial<ITariffsByTab> = useMemo(() => {
        if (!isUnionQuotaTariffsList) {
            return {};
        }

        return tariffList?.find((tariff) => tariff.isRecommended && tariff.products.monthProduct) || {};
    }, [tariffList, isUnionQuotaTariffsList]);

    const { id, price, space } = recommendedTariff?.products?.monthProduct || {};
    const onBuy = useCallback(() => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requestPayment({
            productId: id,
            forceFastCheckout: true,
            onSuccess: () => {
                sendQuotaGa({ action: 'tariff', label: 'buy', tariff: id, amount: price });
                dispatch(CardActions.updateCard({ isSilent: true }));
                dispatch(updateSubscriptionsRequest());
                snackbarController.showSnackbar({
                    type: SnackbarTypes.success,
                    text: 'Подписка успешно оформлена',
                    id: 'quotaCleanerTariffBuy',
                    closable: true,
                });
            },
        });
    }, [dispatch, id, price]);

    return {
        tariffId: id,
        tariffPrice: price,
        tariffValue: space?.value,
        onBuy,
    };
};
